export default "__VITE_ASSET__Bx5pVic4__"